var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tsa-mobile-header"},[_c('div',{attrs:{"id":"tsa-mobile-navigation"}})])
}]

export { render, staticRenderFns }